<template>
  <div>
    <base-alert v-if="error" type="danger" dismissible>
      <!-- TODO: add error translation -->
      {{ error }}
    </base-alert>
    <form v-on:submit.prevent="submit()">
      <div class="row">
        <div class="col-12">
          <p>
            <base-radio inline name="byPublicId" class="ml-3" v-model="model.searchBy" disabled/>
            {{ $t('userAccountsSearch.firstStepSearchByPublicIdDescription') }}
          </p>
        </div>
        <div class="col">
          <base-input
            name="public_id"
            required
            :placeholder="$t('userAccountsSearch.form.publicIdPlaceholder')"
            v-model="model.public_id"
            addon-left-icon="tim-icons icon-tag"
            @focus="model.searchBy = 'byPublicId'"
            ref="input_byPublicId"
          >
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p v-if="$auth.can({account_additional_details: 'read'}, 'permissions')">
            <base-radio inline name="byIdentifier" class="ml-3" v-model="model.searchBy" disabled/>
            {{ $t('userAccountsSearch.firstStepSearchByIdentifierDescription') }}
          </p>
        </div>
        <div class="col" v-if="$auth.can({account_additional_details: 'read'}, 'permissions')">
          <base-input
            name="identifier"
            required
            :placeholder="$t('userAccountsSearch.form.identifierPlaceholder')"
            v-model="model.identifier"
            addon-left-icon="tim-icons icon-badge"
            @focus="model.searchBy = 'byIdentifier'"
            ref="input_byIdentifier"
          >
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>
            <base-radio inline name="byEmail" class="ml-3" v-model="model.searchBy" disabled/>
            {{ $t('userAccountsSearch.firstStepSearchByEmailDescription') }}
          </p>
        </div>
        <div class="col">
          <div class="row">
            <div class="col-md-8 col-sm-12">
              <base-input
                name="email"
                required
                :placeholder="$t('userAccountsSearch.form.emailPlaceholder')"
                v-model="model.email"
                v-validate="modelValidations.email"
                addon-left-icon="tim-icons icon-email-85"
                @focus="model.searchBy = 'byEmail'"
                ref="input_byEmail"
              >
              </base-input>
            </div>
            <div class="col-md-4 col-sm-12">
              <base-input
                name="reference"
                required
                :placeholder="$t('userAccountsSearch.form.referenceKeyPlaceholder')"
                v-model="model.reference_key"
                addon-left-icon="tim-icons icon-key-25"
                @focus="model.searchBy = 'byEmail'"
              >
              </base-input>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="!hideSearchBySerialNumber">
        <div class="col-12">
          <p>
            <base-radio inline name="bySerialNumber" class="ml-3" v-model="model.searchBy" disabled/>
            {{ $t('userAccountsSearch.firstStepSearchBySerialNumberDescription') }}
          </p>
        </div>
        <div class="col">
          <base-input
            name="public_id"
            required
            :placeholder="$t('userAccountsSearch.form.serialNumberPlaceholder')"
            v-model="model.serial_number"
            addon-left-icon="tim-icons icon-credit-card"
            @focus="model.searchBy = 'bySerialNumber'"
            ref="input_bySerialNumber"
          >
          </base-input>
        </div>
      </div>

      <div class="row" v-if="$auth.isAdmin()">
        <div class="col-12">
          <p>
            <base-radio inline name="byAccountId" class="ml-3" v-model="model.searchBy" disabled/>
            {{ $t('userAccountsSearch.firstStepSearchByAccountIdDescription') }}
          </p>
        </div>
        <div class="col">
          <base-input
            name="accountId"
            required
            :placeholder="$t('userAccountsSearch.form.accountIdPlaceholder')"
            v-model="model.account_id"
            addon-left-icon="tim-icons icon-single-02"
            @focus="model.searchBy = 'byAccountId'"
            ref="input_byAccountId"
          >
          </base-input>
        </div>
      </div>

    </form>
  </div>
</template>
<script>
import {BaseAlert, BaseRadio} from 'src/components';
import {mapActions, mapState} from "vuex";

export default {
  name: 'search-account',
  components: {
    BaseAlert,
    BaseRadio
  },
  props: {
    hideSearchBySerialNumber: {
      type: Boolean,
      description: "Will not show search by serial number."
    }
  },
  data() {
    return {
      model: {
        email: '',
        reference_key: '',
        public_id: '',
        serial_number: '',
        identifier: '',
        account_id: '',
        searchBy: 'byPublicId',
      },
      error: null,
      modelValidations: {
        firstName: {
          required: true,
          min: 5
        },
        lastName: {
          required: true,
          min: 5
        },
        email: {
          required: true,
          email: true
        },
        phone: {
          required: true,
          numeric: true
        }
      }
    };
  },
  computed: {
    ...mapState({
      loading: state => state.account.loading,
      searchError: state => state.account.error,
      found: state => state.account.data,
    }),
  },
  methods: {
    ...mapActions(['SearchAccount']),
    submit() {
    },
    async validate() {
      this.error = null;
      await this.SearchAccount(this.model)
      if (this.searchError === null && this.found.id !== '') {
        this.$emit('on-validated', true, this.model);
        // move to second step
        return true
      }
      this.error = this.searchError.body["error"];
      return false
    }
  },
  created() {
    this.$nextTick(() => {
      const a = this.$refs["input_" + this.model.searchBy];
      if (a) {
        a.$el.children[0].children[1].focus()
      }
    })
  },
};
</script>
<style></style>
